export const environment = {
  production: false,
  domainAPIV3: "https://v3-master-api.doinsport.club",
  domainAPIV4: "https://test-actuality-api.doinsport.club",
};
